
/**
 * Copyright (c) Platform Science Inc. All rights reserved.
 */

import moment from 'moment';

export const isTokenStillValid = expirationDate => {
  if (expirationDate === undefined) {
    return false;
  }
  const now = moment();
  return now.isBefore(moment(expirationDate));
};
